import React from 'react';
import Button from '@material-ui/core/Button';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { useTranslation } from 'react-i18next';

export type MetricsRow = {
  key: string;
  name: string;
  vendorName: string;
  quantity: number;
};

interface PreorderMetricsPrintButtonProps {
  rows: MetricsRow[];
  preorderName: string;
  vendorLabel: string;
}

const PreorderMetricsPrintButton = ({ rows, preorderName, vendorLabel }: PreorderMetricsPrintButtonProps) => {
  const { t } = useTranslation('global');

  const handlePrint = () => {
    const html = `
      <!DOCTYPE html><html><head><title>${preorderName}</title>
      <style>
        body { font-family: Arial, sans-serif; padding: 24px; }
        h2 { margin-bottom: 8px; }
        p { margin: 0 0 16px; color: #555; font-size: 13px; }
        table { border-collapse: collapse; width: 100%; }
        th { background: #1976d2; color: white; padding: 8px 12px; text-align: left; }
        th:last-child { text-align: right; }
        td { padding: 8px 12px; border-bottom: 1px solid #e0e0e0; }
        td:last-child { text-align: right; }
        tr:nth-child(even) td { background: #f9f9f9; }
      </style></head><body>
      <h2>${preorderName} — ${t('preorderEventDetails.item-metrics')}</h2>
      <p>${t('preorderEventDetails.vendor')}: ${vendorLabel}</p>
      <table>
        <thead><tr>
          <th>${t('common.name')}</th>
          <th>${t('preorderEventDetails.vendor')}</th>
          <th>${t('preorderEventDetails.sold-items')}</th>
        </tr></thead>
        <tbody>${rows.map(r => `<tr><td>${r.name}</td><td>${r.vendorName}</td><td>${r.quantity}</td></tr>`).join('')}</tbody>
      </table>
      </body></html>`;

    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow?.document;
    if (doc) {
      doc.open();
      doc.write(html);
      doc.close();
      iframe.contentWindow?.focus();
      const originalTitle = document.title;
      document.title = preorderName;
      iframe.contentWindow?.print();
      document.title = originalTitle;
    }

    setTimeout(() => document.body.removeChild(iframe), 1000);
  };

  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={<AssessmentIcon />}
      onClick={handlePrint}
    >
      {t('preorderEventDetails.print-pdf')}
    </Button>
  );
};

export default PreorderMetricsPrintButton;
